function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 倒计时
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 15) + 1
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.sp_hour').html(hours)
      $('.sp_minute').html(minutes)
      $('.sp_second').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    let sp_price1 = 149
    let sp_price2 = 299
    let prods = window.product
    function getCur(productDom){
        let color = productDom.find('#color div.active').attr('data-val')
        let size =  productDom.find('#Size div.active').attr('data-val')
        return prods.filter(item=> item.option1 == color && item.option2 == size)[0]
    }
    function changePrice(productDom){
      let num = productDom.find('.calcNumber').val()
      let price = (getCur(productDom).price * num / 100).toFixed(0)
      let compare = (getCur(productDom).compare_at_price * num / 100).toFixed(0)
      price = (price + '').replace('.', ',')
      compare = (compare + '').replace('.', ',')
      productDom.find('.new').html(price)
      productDom.find('.old').html(compare)
      // let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
      // $(".product-part .price-group .sp-row span").html(off_font);
  }
    function calcTotal(price, num) {
      let _result = Number(price) * Number(num)
      return _result.toFixed(0)
    }
    // 数字框
    $('.reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
      }
      const prodDom = $(this).closest(".product-part")
      changePrice(prodDom)
    })
    $('.add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
      const prodDom = $(this).closest(".product-part")
      changePrice(prodDom)
    })
    let imgArr = [
      'https://cdn.shopify.com/s/files/1/0771/5956/3576/files/20250714-pro-2.webp',
      'https://cdn.shopify.com/s/files/1/0771/5956/3576/files/20250714-pro-3.webp',
      'https://cdn.shopify.com/s/files/1/0771/5956/3576/files/20250714-pro-4.webp',
      'https://cdn.shopify.com/s/files/1/0771/5956/3576/files/20250714-pro-5.webp',
      'https://cdn.shopify.com/s/files/1/0771/5956/3576/files/20250714-pro-6.webp',
      'https://cdn.shopify.com/s/files/1/0771/5956/3576/files/20250714-pro-7.webp',
      'https://cdn.shopify.com/s/files/1/0771/5956/3576/files/20250714-pro-8.webp',
      'https://cdn.shopify.com/s/files/1/0771/5956/3576/files/20250714-pro-9.webp',
      'https://cdn.shopify.com/s/files/1/0771/5956/3576/files/20250714-pro-10.webp',
      'https://cdn.shopify.com/s/files/1/0771/5956/3576/files/20250714-pro-11.webp',
      'https://cdn.shopify.com/s/files/1/0771/5956/3576/files/20250714-pro-12.webp',
      'https://cdn.shopify.com/s/files/1/0771/5956/3576/files/20250714-pro-13.webp',
      'https://cdn.shopify.com/s/files/1/0771/5956/3576/files/20250714-pro-14.webp',
      'https://cdn.shopify.com/s/files/1/0771/5956/3576/files/20250714-pro-15.webp',
      'https://cdn.shopify.com/s/files/1/0771/5956/3576/files/20250714-pro-16.webp',
      'https://cdn.shopify.com/s/files/1/0771/5956/3576/files/20250714-pro-17.webp',
      'https://cdn.shopify.com/s/files/1/0771/5956/3576/files/20250714-pro-18.webp',
      'https://cdn.shopify.com/s/files/1/0771/5956/3576/files/20250714-pro-19.webp',
      'https://cdn.shopify.com/s/files/1/0771/5956/3576/files/20250714-pro-20.webp',
      'https://cdn.shopify.com/s/files/1/0771/5956/3576/files/20250714-pro-21.webp',
      'https://cdn.shopify.com/s/files/1/0771/5956/3576/files/20250714-pro-22.webp',
    ]
    $('#color .option').click(function () {
       const prodDom = $(this).closest(".product-part")
      var index = $(this).index()
      var index2 = prodDom.find('#Size .option.active').index()
      $(this).addClass('active').siblings().removeClass('active')
      changeOption(index, index2,prodDom)
       changePrice(prodDom)
    })
    $('#Size .option').click(function () {
      const prodDom = $(this).closest(".product-part")
      var index = prodDom.find('#color .option.active').index()
      var index2 = $(this).index()
      $(this).addClass('active').siblings().removeClass('active')
      changeOption(index, index2,prodDom)
           
      changePrice(prodDom)
    })
    function changeOption(index, index2,prodDom) {
      if (index >= 0) {
        prodDom.find('.sp-pro-imgs img').attr('src', imgArr[index2 + index * 3])
      }
      if (index2 == 1 || index2 == 2) {
        prodDom.find('.sp-pro-free').show()
      } else {
        prodDom.find('.sp-pro-free').hide()
      }
    }
    $('.sp-part1-btn,.sp-header-btn').click(function () {
      $('.mask').css('display', 'flex')
    })
    $('.close-pop').click(function () {
      $('.mask').css('display', 'none')
    })
    $('.sp-btn-style').click(function(){
    const prodDom = $(this).closest(".product-part")
    let num = prodDom.find('.calcNumber').val()
    window.location.href = '/cart/' + getCur(prodDom).id + ':' + num
  })
    // style选项
    $('.cart-btn').click(function () {
      $(this).children('img').addClass('on')
      setTimeout(function () {
        $('.cart-btn').children('img').removeClass('on')
      }, 500)
      $('.sp-header-top .sp-cart').addClass('on')
      setTimeout(function () {
        $('.sp-header-top .sp-cart').removeClass('on')
      }, 500)
    })
    // 加入购物车
    addCart()
    function addCart() {
      // 加入购物车
     
      $('.addCerts').click(function () {
        // do something here
         const prodDom = $(this).closest(".product-part")
        var data = {
          id: getCur(prodDom).id,
          quantity: prodDom.find('.calcNumber').val(),
        };
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: data,
          success: function () {
            $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
              $("#cardNum").html(result.item_count);
            });
          },
          dataType: "json",
        });
        var number =
          Number($('.sp-cart #cardNum').html()) + Number(prodDom.find('.calcNumber').val())
        // $('.sp-cart #cardNum').html(number)
        if (number > 0) {
          $('.sp-cart .num').css('background', '#cf0101')
        } else {
          $('.sp-cart .num').css('background', '#919191')
        }
        var img = prodDom.find('.top-product img')
        var flyer = img[0].cloneNode(true)
        flyer.classList.add('clone')
        prodDom.append(flyer)
        prodDom.find('.clone').css({
          width: img.width(),
          height: img.height(),
          position: 'fixed',
          top: img[0].offsetTop,
          left: img.offset().left,
          'z-index': '99',
        })
        var offset = $('.sp-cart')[0].getBoundingClientRect()
       $('.sp-cart').addClass('shake')
        setTimeout(() => {
         $('.sp-cart').removeClass('shake')
        }, 1000)
        let finish = $('.sp-cart')
        prodDom.find('.clone').animate(
          {
            top: finish[0].offsetTop + 117,
            left: finish[0].offsetLeft + finish.width() / 2 - 15,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          1000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach() // 完成动画后移除克隆的图片
              }
            )
          }
        )
      })
    }
    // 文字标题动画
    const graduallyList = document.getElementsByClassName('gradually')
    for (let gradually of graduallyList) {
      const spans = gradually.querySelectorAll('span'),
        paragraph = gradually.querySelector('.sp-sub-title'),
        observer = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                spans.forEach((span, index) => {
                  ;(span.style.animation = 'swift-up-fade 0.5s ease forwards'),
                    (span.style.animationDelay = `${index * 0.15}s`)
                  const i = span.querySelector('i')
                  i &&
                    ((i.style.animation = 'swift-up-fade 0.5s ease forwards'),
                    (i.style.animationDelay = `${index * 0.15}s`))
                })
                const totalDelay = spans.length * 0.15 + 0.3
                paragraph &&
                  ((paragraph.style.animation =
                    'swift-up-fade 0.5s ease forwards'),
                  (paragraph.style.animationDelay = `${totalDelay}s`)),
                  observer.unobserve(gradually)
              }
            })
          },
          { threshold: 0.3 }
        )
      observer.observe(gradually)
    }
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach(subArray => {
        subArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach(url => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop =
          targetElement.offsetTop -
          $('.sp-header-top').height() -
          $('.time-part').height()
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
